"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useScrollableStack = useScrollableStack;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var _responsiveHelpers = require("responsive-helpers");

var _useHover = _interopRequireDefault(require("../useHover"));

var _animatedScrollTo = _interopRequireDefault(require("animated-scroll-to"));

var __jsx = _react["default"].createElement;

function easeOutExpo(x) {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}

function getNextPos(scrollableContainerRef, spacerRef, itemRefs) {
  var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var spacerWidth = spacerRef.current.getBoundingClientRect().width;
  var containerRect = scrollableContainerRef.current.getBoundingClientRect();
  var containerWidth = containerRect.width - spacerWidth * 2;
  var closestItem;
  var closestDiff = 999999;

  for (var i = 0; i < itemRefs.current.length; i++) {
    var item = itemRefs.current[i];
    var left = item.current.getBoundingClientRect().left - containerRect.left;
    var diff = Math.abs(left + containerWidth * direction - spacerWidth);

    if (diff < closestDiff) {
      closestItem = item.current;
      closestDiff = diff;
    }
  }

  var pos = scrollableContainerRef.current.scrollLeft + (closestItem.getBoundingClientRect().left - containerRect.left - spacerWidth); // snap to boundaries (1px problem)

  pos = Math.ceil(pos);

  if (Math.abs(pos) < 3) {
    pos = 0;
  }

  return pos;
}

function _scrollTo(container, pos) {
  container.style.willChange = "scroll-position";
  (0, _animatedScrollTo["default"])([pos, null], {
    elementToScroll: container,
    easing: easeOutExpo,
    minDuration: 500,
    maxDuration: 500
  }).then(function () {
    container.style.willChange = "auto";
  });
}
/**
 * Helper component placing components next to each other with gutter.
 *
 * Gutter can be responsive but items layout can not. So it's usable ONLY if on all resolutions items will be next to each other and won't wrap.
 */


function useScrollableStack(props) {
  var scrollableContainerRef = (0, _react.useRef)(null);
  var floatingElementRef = (0, _react.useRef)(null);

  var _useResponsiveHelpers = (0, _.useResponsiveHelpers)(),
      currentValue = _useResponsiveHelpers.currentValue; //
  // const scrollTo = x => {
  //   scrollableContainerRef.current.scroll({
  //     left: x,
  //     behavior: "smooth"
  //   });
  // };


  var _useState = (0, _react.useState)(true),
      isAtStart = _useState[0],
      setIsAtStart = _useState[1];

  var _useState2 = (0, _react.useState)(true),
      isAtEnd = _useState2[0],
      setIsAtEnd = _useState2[1];

  var itemRefs = (0, _react.useRef)(null);
  var spacerRef = (0, _react.useRef)(null);

  if (!itemRefs.current) {
    itemRefs.current = [];

    for (var i = 0; i < props.length; i++) {
      itemRefs.current.push(_react["default"].createRef());
    }
  }

  var setFloatingElementIndex = function setFloatingElementIndex(n) {
    if (!floatingElementRef.current) {
      return;
    }

    if (typeof props.length !== "number") {
      throw new Error("You're must pass 'length' parameter to useScrollableStack in order to make it work with floating element!!!");
    }

    var offsetLeft;
    var width;

    if (n === null) {
      offsetLeft = 0;
      width = 0;
    } else {
      offsetLeft = itemRefs.current[n].current.offsetLeft;
      width = itemRefs.current[n].current.clientWidth;
    }

    floatingElementRef.current.style.transform = "translateX(".concat(offsetLeft, "px)");
    floatingElementRef.current.style.width = "".concat(width, "px");
  };

  (0, _react.useEffect)(function () {
    setFloatingElementIndex(typeof props.initialFloatingElementIndex === "number" ? props.initialFloatingElementIndex : 0);
    setTimeout(function () {
      if (floatingElementRef.current) {
        floatingElementRef.current.style.transition = "all .15s ease-out";
      }
    }, 500);
  }, []);
  (0, _react.useEffect)(function () {
    var elem = scrollableContainerRef.current;

    var listener = function listener() {
      var isStart = elem.scrollLeft <= 0;
      var isEnd = elem.scrollWidth - elem.scrollLeft <= elem.clientWidth;
      setIsAtStart(isStart);
      setIsAtEnd(isEnd);
    };

    listener();
    elem.addEventListener("scroll", listener, {
      passive: true
    });
    return function () {
      elem.removeEventListener("scroll", listener);
    };
  }, []);
  var ret = {
    scrollTo: function scrollTo(pos) {
      _scrollTo(scrollableContainerRef.current, pos);
    },
    isAtStart: isAtStart,
    isAtEnd: isAtEnd
  }; // const currentContainerWidth = currentValue(padding) * 2;

  var previousButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, 1);

      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  var nextButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, -1);

      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  return (0, _objectSpread2["default"])({}, ret, {
    scrollableContainerRef: scrollableContainerRef,
    itemRefs: itemRefs.current,
    floatingElementRef: floatingElementRef,
    spacerRef: spacerRef,
    setFloatingElementIndex: setFloatingElementIndex,
    previousButtonProps: previousButtonProps,
    nextButtonProps: nextButtonProps
  });
}

function ScrollableStack(props) {
  var sx = props.sx,
      children = props.children,
      controller = props.controller,
      previousButton = props.previousButton,
      nextButton = props.nextButton,
      gap = props.gap,
      align = props.align,
      innerMargin = props.innerMargin,
      itemSize = props.itemSize,
      itemsVisible = props.itemsVisible,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "children", "controller", "previousButton", "nextButton", "gap", "align", "innerMargin", "itemSize", "itemsVisible"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var rootRef = (0, _react.useRef)(null);
  var isRootHovered = (0, _useHover["default"])(rootRef);
  gap = gap || customSx.$gap || 0;
  align = align || customSx.$align || "left";
  var padding = innerMargin || customSx.$innerMargin || 0;

  if (!controller) {
    controller = useScrollableStack((0, _objectSpread2["default"])({}, props, {
      length: props.children.length
    }));
  }

  var itemProps;
  itemSize = itemSize || customSx.$itemSize;
  itemsVisible = itemsVisible || customSx.$itemsVisible;

  if (itemSize) {
    itemProps = {
      width: itemSize
    };
  } else if (itemsVisible) {
    // TODO: unify responsive values arithmetics
    (0, _.responsiveValueForEach)(align, function (val) {
      if (val !== "left") {
        console.warn("Warning: ScrollableStack uses $itemsVisible + $align, this behaviour is not allowed. If you want to use $align, please use $itemSize property or go with natural item widths.");
      }
    });
    align = "left";
    var itemsVisibleMap = (0, _.responsiveValueToRangeMap)(itemsVisible);
    var paddingRs = (0, _.responsiveValueToResponsiveSize)(padding);
    var gapRs = (0, _.responsiveValueToResponsiveSize)(gap);
    var multiplier = {};
    itemsVisibleMap.forEach(function (itemsVisible, range) {
      multiplier[range.from] = (itemsVisible - 1) / itemsVisible;
    });
    var base = (0, _responsiveHelpers.rs)("100%"); // if (!props.itemsVisibleIncludeMargins) {

    base = base.subtract(paddingRs).subtract(paddingRs); // }

    var size = base.divide(itemsVisibleMap).subtract(gapRs.multiply(multiplier));
    itemProps = size.cssObject("width");
  }

  var floatingElement;

  if (customSx.$floatingElement) {
    floatingElement = (0, _.createElement)((0, _.getElementSpec)(customSx.$floatingElement, {
      __type: _Box["default"],
      position: "absolute",
      width: 0,
      zIndex: customSx.$floatingElementUnder ? -1 : 1,
      bottom: 0,
      left: 0
    }, {}), {
      _ref: controller.floatingElementRef
    });
  }
  /**
   * Inner container styles
   */


  var innerContainerStyles = {
    width: (0, _.responsiveValueMap)(align, function (x) {
      return x === "left" ? "100%" : undefined;
    }),
    ml: (0, _.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "right" ? "auto" : "initial";
    }),
    mr: (0, _.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "left" ? "auto" : "initial";
    })
  };

  var childrenArray = _react["default"].Children.toArray(children); // TODO: floating line!!! (rect) => ...

  /**
   * Buttons
   */


  if (previousButton) {
    if (typeof previousButton === "function") {
      previousButton = previousButton((0, _objectSpread2["default"])({}, controller, {
        isParentHovered: isRootHovered
      }));
    }

    if (_react["default"].isValidElement(previousButton)) {
      previousButton = {
        button: previousButton
      };
    }

    previousButton.offset = previousButton.offset || 0;
    previousButton.hideOnTouch = previousButton.hideOnTouch || true;

    if (typeof previousButton.button === "function") {
      previousButton.button = previousButton.button({
        buttonProps: controller.previousButtonProps
      });
    }
  }

  if (nextButton) {
    if (typeof nextButton === "function") {
      nextButton = nextButton((0, _objectSpread2["default"])({}, controller, {
        isParentHovered: isRootHovered
      }));
    }

    if (_react["default"].isValidElement(nextButton)) {
      nextButton = {
        button: nextButton
      };
    }

    nextButton.offset = nextButton.offset || 0;
    nextButton.hideOnTouch = nextButton.hideOnTouch || true;

    if (typeof nextButton.button === "function") {
      nextButton.button = nextButton.button({
        buttonProps: controller.nextButtonProps
      });
    }
  }

  return __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative"
    }, css),
    _ref: rootRef
  }, __jsx(_Box["default"], {
    sx: [{
      position: "relative",
      display: "flex",
      height: "100%",
      minHeight: "inherit",
      overflowX: "auto",
      "::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    }],
    _ref: controller.scrollableContainerRef
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap"
    }, innerContainerStyles)
  }, floatingElement, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding,
      zIndex: 0
    },
    ref: controller.spacerRef
  }), childrenArray.map(function (child, index) {
    return __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "relative",
        marginRight: index === childrenArray.length - 1 ? 0 : gap,
        flexGrow: 0,
        flexShrink: 0
      }, itemProps),
      key: child.key,
      _ref: controller.itemRefs[index]
    }, child);
  }), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding
    }
  }))), previousButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      left: padding,
      top: 0,
      height: "100%",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative",
      left: previousButton.offset
    }, previousButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, _react["default"].cloneElement(previousButton.button, controller.previousButtonProps))), nextButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      right: padding,
      top: 0,
      height: "100%",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative",
      right: nextButton.offset
    }, nextButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, _react["default"].cloneElement(nextButton.button, controller.nextButtonProps))));
}

var _default = ScrollableStack;
exports["default"] = _default;